import { useGlobalStore } from "@/frontend/store/GlobalStore";
import { ModelWithFile } from "@/frontend/typings/types";
import { I18n } from "@/i18n/I18n";
import { FileSubjectTypes } from "@/types/fileTypes";
import { useState } from "react";
import { Button, Modal, Form } from "react-bootstrap";
import { FileUploadWrapper } from "../files/FileUploadWrapper";

export function EditImageButton(props: { fileSource?: string, model: ModelWithFile, refetchSubject: (id: string) => Promise<void>, subjectType: FileSubjectTypes }) {
  const { model, refetchSubject, subjectType } = props;
  const [ showModal, setShowModal ] = useState<boolean>(false);
  const [ file, setFile ] = useState<File | undefined>(undefined);
  const deleteFile = useGlobalStore(state => state.deleteFile);
  const createFile = useGlobalStore(state => state.createFile);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [uploadProgress, setUploadProgress] = useState<number>(0);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newFile = event.target.files?.[0];
    if (!newFile) return;
    setFile(newFile);
  };

  const handleSubmit = async () => {
    setIsSubmitting(true);
    if (((file instanceof File || !file) && model.file)) {
      await deleteFile(model.file.id);
    }
    if (file instanceof File) {
      await createFile({ fileName: file.name, subjectId: model.id, subjectType }, file, () => void refetchSubject(model.id), setUploadProgress);
    }
    setIsSubmitting(false);
    setUploadProgress(0);
    setShowModal(false);
  };
  
  return (
    <div>
      <Button className="mt-2" size="sm" variant="primary" onClick={() => setShowModal(true)}>
        {I18n.get('editImage')}
      </Button>
      {showModal && (
        <Modal show={showModal} onHide={() => setShowModal(false)} backdropClassName="nested-modal-backdrop">
          <Modal.Header closeButton>
            <Modal.Title>{I18n.get('editImage')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <FileUploadWrapper uploading={isSubmitting} uploadProgress={uploadProgress}>
                <Form.Label className="mt-3">{I18n.get('uploadImage')}</Form.Label>
                <Form.Control accept="image/*" aria-label={I18n.get('uploadImage')} type="file" onChange={handleFileChange} />
              </FileUploadWrapper>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>{I18n.get('cancel')}</Button>
            <Button variant="primary" onClick={() => void handleSubmit()} disabled={isSubmitting}>
            {isSubmitting ? I18n.get('saving') : I18n.get('save')}
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
}